import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBarFinal from './Home/NavBarFinal/NavBarFinal';
import BackgroundDecorations from './Common/BackgroundDecorations';

const HomeFinal = () => {
    return (
        <div className="page-container">
            <NavBarFinal />
            <BackgroundDecorations />
            <main className="content-container">
                <Outlet />
            </main>
        </div>
    );
};

export default HomeFinal;
